export function cleanObject(object: any, includeNull = false) {
    const entries = Object.entries(object).filter(
        entry => entry[1] !== undefined && (!includeNull || entry[1] !== null)
    );
    return Object.fromEntries(entries);
}

export function compose(...rest: any[]) {
    return (x: any) => rest.reduceRight((y, f) => f(y), x);
}

export function getDefined(...values: any[]) {
    const value = values.find(value => value !== null && value !== undefined);
    return value !== undefined ? value : null;
}

export function getPhotoCrop(url: string) {
    return `${url}?crop=entropy&fit=crop&w=720`;
}

export function getShallowEqual(a: any, b: any) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(key => a[key] === b[key]);
}

export function getTime() {
    return new Date().getTime();
}

export function getUrl(path: string) {
    if (path?.startsWith('http')) {
        return path;
    }
    return `${process.env.NEXT_CONFIG_BASE_PATH || ''}${path}`;
}

export function isStagingHostname(hostname?: string | null): boolean {
    return (hostname || '').toLowerCase() === 'staging.kromatic.com';
}

export function getKromaticSiteOriginForHost(hostname?: string | null): string | null {
    const host = (hostname || '').toLowerCase();

    if (host === 'staging.kromatic.com') {
        return 'https://staging.kromatic.com';
    }

    if (host === 'kromatic.com' || host === 'www.kromatic.com') {
        return 'https://kromatic.com';
    }

    return null;
}

export function resolveKromaticSiteUrl(url: string, runtimeHostname?: string): string {
    if (!url) {
        return url;
    }

    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return url;
    }

    const host = parsed.hostname.toLowerCase();
    const isKnownKromaticHost =
        host === 'kromatic.com' || host === 'www.kromatic.com' || host === 'staging.kromatic.com';
    if (!isKnownKromaticHost) {
        return url;
    }

    const resolvedOrigin = getKromaticSiteOriginForHost(
        runtimeHostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
    );
    if (!resolvedOrigin) {
        return url;
    }

    const target = new URL(resolvedOrigin);
    parsed.protocol = target.protocol;
    parsed.host = target.host;
    return parsed.toString();
}

export function isDefined(value: any) {
    return value !== null && value !== undefined;
}

export function validateEmail(email: string) {
    return !!/^.+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.exec(email);
}

export function wait(delay: number) {
    return new Promise<void>(resolve => setTimeout(resolve, delay));
}
